module.exports = __webpack_public_path__ + "assets/img/logo.50f3e91a.png";